import React, { Component } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import css from './sub-heading.scss';

import {
    ALL_CLASSES,
    SELECTED_CLASS,
    SKILL_QUESTS_MASTERY,
    // SELECTED_GROUP,
    // SELECTED_STUDENT,
    SELECTED_REPORT
    // SELECTED_DATE
} from '../report-filters/filter-constants';
// import {
//     dateFilterPropType,
//     filterPropType
// } from '../report-filters/filter-prop-types';
import activeFiltersSelectors from '../report-filters/redux/active-filters/active-filters-selectors';
import exportReportActions from './export-report/export-report-actions';

import SubHeadingButtons from './sub-heading-buttons/sub-heading-buttons';
import SubHeadingHeader from './sub-heading-header/sub-heading-header';
import PopUpMenu from '../popup-menu/popup-menu';
import { translate } from '../../helpers/locale-helpers';

/* global window */

/**
 * Sub Heading Component
 * Displays information which is selected via filter component - page title & selected date range
 */
export class SubHeading extends Component {
    static propTypes = {
        // activeFilters: PropTypes.shape({
        //     [SELECTED_CLASS]: filterPropType,
        //     [SELECTED_GROUP]: filterPropType,
        //     [SELECTED_STUDENT]: filterPropType,
        //     [SELECTED_REPORT]: filterPropType,
        //     [SELECTED_DATE]: dateFilterPropType
        // }),
        isAdmin: PropTypes.bool,
        isExportEnabled: PropTypes.bool,
        isParticipationReport: PropTypes.bool,
        exportReport: PropTypes.func,
        exportedReport: PropTypes.shape({
            key: PropTypes.string,
            resourcesMethod: PropTypes.string
        }),
        downloadStudentReport: PropTypes.func,
        isProcessingDownload: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            label: '',
            dateRange: '',
            isDownloadEnabled: false,
            shouldDisplayDropdown: false,
            clickedOutside: false
        };
    }

    componentDidMount() {
        const { isAdmin } = this.props;

        if (isAdmin != null) {
            this.manageDownloadEnabled(this.props);
        }
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    componentWillReceiveProps(newProps) {
        const { exportedReport } = this.props;
        const { exportedReport: newExportedReport, isAdmin } = newProps;

        if (exportedReport !== newExportedReport) {
            this.downloadReport(newExportedReport);
        }

        if (isAdmin !== null) {
            this.manageDownloadEnabled(newProps);
        }
    }

    getIsDownloadEnabled = (className, selectedReportName) =>
        // Download button is not shown for class level
        className &&
        className !== ALL_CLASSES &&
        // Skill quests mastery sub heading buttons are found one level deeper as per UX requirements
        selectedReportName !== SKILL_QUESTS_MASTERY;

    manageDownloadEnabled = (newProps) => {
        const { activeFilters } = newProps;
        this.setState({
            isDownloadEnabled: this.getIsDownloadEnabled(
                activeFilters[SELECTED_CLASS].name,
                activeFilters[SELECTED_REPORT].name
            )
        });
    };

    downloadReport = (exportedReport) => {
        window.open(exportedReport.downloadUrl, '_blank');
    };

    clickHandler = () => {
        this.setState({
            ...this.state,
            shouldDisplayDropdown: !this.state.shouldDisplayDropdown,
            clickedOutside: false
        });
    };

    myRef = React.createRef();

    handleClickOutside = (e) => {
        if (!this.myRef.current.contains(e.target)) {
            this.setState({
                shouldDisplayDropdown: false,
                clickedOutside: true
            });
        }
    };

    render() {
        const {
            isExportEnabled,
            isParticipationReport,
            exportReport,
            downloadStudentReport,
            isProcessingDownload
        } = this.props;
        const { isDownloadEnabled } = this.state;
        const options = [
            { label: translate('DropDown Button Text Option - PDF') },
            { label: translate('DropDown Button Text Option - Excel') }
        ];
        const isStudentRoute = window.location.href.includes('student');
        const showPopup =
            this.state.shouldDisplayDropdown &&
            !this.state.clickedOutside &&
            !isStudentRoute;

        return (
            <div className={css.component}>
                <SubHeadingHeader />
                <SubHeadingButtons
                    isExportEnabled={isExportEnabled}
                    isProcessingDownload={isProcessingDownload}
                    isDownloadEnabled={isDownloadEnabled}
                    onDownloadReport={downloadStudentReport}
                    onExportReport={
                        isParticipationReport && !isStudentRoute
                            ? this.clickHandler
                            : exportReport
                    }
                    shouldDisplayDropdown={this.state.shouldDisplayDropdown}
                    forwardedRef={this.myRef}
                />
                {showPopup && (
                    <PopUpMenu
                        options={options}
                        onClickHandler={this.clickHandler}
                        downloadReports={exportReport}
                    />
                )}
            </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        activeFilters: activeFiltersSelectors.selectActiveFilters(state),
        exportedReport: state.exportedReport,
        isAdmin: state.isAdmin,
        isProcessingDownload: state.downloadReport.isProcessingDownload
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            exportReport: exportReportActions.exportReport,
            downloadStudentReport: exportReportActions.downloadStudentReport
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(styleable(css)(SubHeading));



// WEBPACK FOOTER //
// ./components/sub-heading/sub-heading.js